import styled from "styled-components/macro";
import { COLORES } from "../../constants";

export const Container = styled.div`
  .hidden {
    display: none;
  };
  width:100%;
`;

export const Label = styled.div`
  ffont-size: 15px;
  margin-bottom:10px;
  font-weight:bold;
  color: ${COLORES.GRIS_OSCURO};
`;

export const RadioContainer = styled.div`
  display: flex;
  justify-content: space-between; /* Espacio uniforme entre los radios */
  align-items: center; /* Centrar los radios verticalmente */
  width: 100%;
`;

export const RadioLabel = styled.label`
  align-items: center;
  justify-content: center;
  width: calc(100% / 3); /* Cada radio ocupa un tercio del contenedor */
  text-align: center; /* Asegura que el texto esté centrado */
  padding: 0.5rem; /* Espaciado interno */
  box-sizing: border-box; /* Asegura que el padding no afecte el ancho */
`;

export const RadioInput = styled.input`
  height: 1rem;
  width: 1rem;
  cursor: pointer;
  margin-right: 0.5rem; /* Espaciado entre el radio y la etiqueta */
  flex-shrink: 0; /* Asegura que el tamaño del radio no se reduzca */

  &:disabled {
    cursor: not-allowed;
    opacity: 0.6;
  }
`;